import { Box, TextField } from '@material-ui/core';
import { State, StateTransitionCondition } from '@sierralabs/workflow';

import ConfirmDialog from '../../../../common/dialogs/ConfirmDialog';
import { TaskContext } from '../../../tasks/Task.machine';
import {
  TransitionConditionConfiguratorProps,
  TransitionConditionDisplayProps,
  TransitionConditionPlugin
} from '../TransitionConditionPlugin';

const ConfirmConfigurator: React.FC<TransitionConditionConfiguratorProps> = ({
  taskType,
  event,
  condition,
  onChange
}) => {
  return (
    <>
      <Box mt={2}>
        <TextField
          variant='outlined'
          fullWidth
          label='Dialog Title'
          value={condition.params?.title || ''}
          onChange={event => {
            if (condition.params) {
              condition.params.title = event.target.value;
              onChange?.({ ...condition });
            }
          }}
        />
      </Box>
      <Box mt={2}>
        <TextField
          variant='outlined'
          fullWidth
          label='Confirm Message'
          value={condition.params?.message || ''}
          onChange={event => {
            if (condition.params) {
              condition.params.message = event.target.value;
              onChange?.({ ...condition });
            }
          }}
        />
      </Box>
    </>
  );
};

const ConfirmDisplay: React.FC<TransitionConditionDisplayProps> = ({
  condition
}) => {
  return <>Confirm Dialog</>;
};

export const ConfirmPlugin: TransitionConditionPlugin = {
  type: 'confirm',
  label: 'Confirm Dialog',
  configurator: ConfirmConfigurator,
  display: ConfirmDisplay,
  validate: (condition: Partial<StateTransitionCondition>) => {
    return true;
  },
  guard: (state: State<TaskContext>, params, render) => {
    console.log('guards: confirm', state, params);
    if (
      state.isSimulation ||
      state.context.skipTransitionConditionPlugins?.includes(ConfirmPlugin.type)
    ) {
      return true;
    }
    return new Promise(resolve => {
      render?.(
        <ConfirmDialog
          title={params.title || ''}
          message={params.message || ''}
          open={true}
          onCancel={() => {
            render?.(undefined);

            resolve(false);
          }}
          onConfirm={() => {
            render?.(undefined);
            resolve(true);
          }}
        />
      );
    });
  }
};
